import React from 'react';
import { motion } from 'framer-motion';
import { useCikContext } from '../../Context/CentralIndustrisContaxtProvider';
import './Gallery.css';

// Importing existing high-res assets for the masterpieces
import masterpiece1 from '../../assets/images/service-v1-1.jpg';
import masterpiece2 from '../../assets/images/trust01.jpg';
import masterpiece3 from '../../assets/images/trust02.jpg';
import masterpiece4 from '../../assets/images/welcome-01.jpg';
import masterpiece5 from '../../assets/images/about_img01.jpg';
import masterpiece6 from '../../assets/images/welcome-02.jpg';

const MASTERPIECES = [
  { id: 1, src: masterpiece1, title: 'Titan Roofing Co.', class: 'item-1' },
  { id: 2, src: masterpiece2, title: 'EverSafe Roofing Solutions', class: 'item-2' },
  { id: 3, src: masterpiece3, title: 'SkyShield Roofing', class: 'item-3' },
  { id: 4, src: masterpiece4, title: 'SolidTop Roof Works', class: 'item-4' },
  { id: 5, src: masterpiece5, title: 'PeakGuard Roofs', class: 'item-5' },
  { id: 6, src: masterpiece6, title: 'BlueRidge Roofing', class: 'item-6' },
];

function Gallery() {
  const { setEachImageStatus, setEachImage } = useCikContext();

  const openLightbox = (imgSrc) => {
    setEachImage(imgSrc);
    setEachImageStatus(true);
  };

  return (
    <section className="masterpieces" id="Gallery">
      <div className="container">

        {/* ── Centered Header ─────────────────────────── */}
        <motion.div
          className="masterpieces__header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="masterpieces__badge">BUILT TO LAST</div>
          <h2 className="masterpieces__title">Explore Our Roofing Masterpieces</h2>
          <p className="masterpieces__desc">
            Take a look at our finest roofing projects — each crafted with precision, durability, and style.
            From residential homes to commercial buildings craftsmanship that set us apart.
          </p>
        </motion.div>

        {/* ── Custom Spanned Grid ─────────────────────── */}
        <div className="masterpieces__grid">
          {MASTERPIECES.map((item, idx) => (
            <motion.div
              key={item.id}
              className={`masterpieces__item ${item.class}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              onClick={() => openLightbox(item.src)}
            >
              <div className="masterpieces__overlay">
                <span className="masterpieces__project-name">{item.title}</span>
              </div>
              <img src={item.src} alt={item.title} />
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Gallery;
